import { Description, Label } from "@/components/field";
import { Switch } from "@/components/switch";

interface FullWidthSwitchProps {
  description?: string;
  disabled?: boolean;
  isSelected: boolean;
  label: string;
  onChange: (isSelected: boolean) => void;
}

export function FullWidthSwitch({
  description,
  disabled,
  isSelected,
  label,
  onChange,
}: FullWidthSwitchProps) {
  return (
    <div className="rounded-lg border border-border-primary px-4 py-3 min-h-[60px] bg-bg-primary">
      <div className="flex items-center justify-between gap-3">
        <div className="flex-1">
          <Label className="text-text-primary font-semibold">{label}</Label>
          {description && (
            <Description className="text-text-tertiary">
              {description}
            </Description>
          )}
        </div>
        <Switch
          isDisabled={disabled}
          isSelected={isSelected}
          onChange={onChange}
        />
      </div>
    </div>
  );
}
